import {Controller} from "@hotwired/stimulus"
import Cleave from 'cleave.js';

// Connects to data-controller="ip"
export default class extends Controller {
  static targets = [
    "buttonView", "generalData", "commercialTerms", "participedGame", "billing", "renewals",
    "emails", "addLink", "removeLink", "template",
    "buttonLanguage", "inputLanguage",
    "advanceAmount", "advanceConsumedAmount", "advanceActive", "hasAdvance", "differentPercent", "applicablePercent", "advanceHidden",
    "buttonCalculationBase", "inputCalculationBase", "buttonPeriodicityBase", "inputPeriodicityBase",
    "input", "game",
  ]

  connect() {
    if (this.hasEmailsTarget) {
      if (this.emailsTarget.children.length === 0) {
        //this.addEmail();
      }
    }

    if (this.hasHasAdvanceTarget) {
      this.toggleBasedOnAdvanceState();
    }

    if (this.hasAdvanceAmountTarget) {
      this.updateAdvanceActiveState();
    }

    if (this.hasApplicablePercentTarget && this.hasDifferentPercentTarget) {
      this.syncApplicablePercentState(this.differentPercentTarget.checked);
    }

    if (this.hasGeneralDataTarget) {
      this.updateViewButtons('general-data');
      this.showView('generalData');
    }

    const cleaveTargets = [
      "advanceAmount"
    ];

    cleaveTargets.forEach(target => {
      const hasTargetFunction = `has${target.charAt(0).toUpperCase() + target.slice(1)}Target`;
      if (this[hasTargetFunction]) {
        const inputElement = this[target + "Target"];
        // Store the current value and convert decimal point to comma if needed
        const currentValue = inputElement.value;
        const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
        
        new Cleave(inputElement, {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.'
        });
        
        // Set the formatted value after Cleave initialization
        if (formattedValue) {
          inputElement.value = formattedValue;
        }
      }
    });
  }

  // Change windows-----------------------------------------------------------
  changeView(event) {
    event.preventDefault();
    let selectedView = event.currentTarget.dataset.view;
    this.updateViewButtons(selectedView);

    switch (selectedView) {
      case 'general-data':
        this.showView('generalData');
        break;
      case 'commercial-terms':
        this.showView('commercialTerms');
        break;
      case 'participed-game':
        this.showView('participedGame');
        break;
      case 'billing':
        this.showView('billing');
        break;
      case 'renewals':
        this.showView('renewals');
        break;
    }
  }

  showView(viewName) {
    this.generalDataTarget.classList.add("opacity-0");
    this.commercialTermsTarget.classList.add("opacity-0");
    this.participedGameTarget.classList.add("opacity-0");
    this.billingTarget.classList.add("opacity-0");
    this.renewalsTarget.classList.add("opacity-0");

    setTimeout(() => {
      this.generalDataTarget.classList.add("hidden");
      this.commercialTermsTarget.classList.add("hidden");
      this.participedGameTarget.classList.add("hidden");
      this.billingTarget.classList.add("hidden");
      this.renewalsTarget.classList.add("hidden");

      this[viewName + 'Target'].classList.remove("hidden");
      setTimeout(() => {
        this[viewName + 'Target'].classList.remove("opacity-0");
      }, 35);
    }, 300);
  }

  updateViewButtons(selectedView) {
    this.buttonViewTargets.forEach((button) => {
      if (button.dataset.view === selectedView) {
        button.classList.add('border-t')
        button.classList.add('border-r')
        button.classList.add('border-l')
        button.classList.add('mb-[-1px]')
        button.classList.add('bg-white')
        button.classList.remove('text-gray-400')

      } else {
        button.classList.remove('border-t')
        button.classList.remove('border-r')
        button.classList.remove('border-l')
        button.classList.add('text-gray-400')
        button.classList.remove('mb-[-1px]')
      }
    });
  }

  // email ---------------------------------------------------------------
  addEmail(event) {
    if (event) event.preventDefault();
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime());
    this.emailsTarget.insertAdjacentHTML('beforeend', content);
  }

  removeEmail(event) {
    event.preventDefault()

    let wrapper = event.target.closest(".nested-fields")
    if (wrapper.dataset.newRecord == 'true') {
      wrapper.remove()
    } else {
      wrapper.querySelector(".destroy-field").value = '1'
      wrapper.style.display = 'none'
    }
  }


  // language ----------------------------------------------------------------
  changeLanguage(event) {
    event.preventDefault();
    const selectedLanguage = event.currentTarget.dataset.language;
    this.inputLanguageTarget.value = selectedLanguage;
    this.updateButtonStyles();
  }

  updateButtonStyles() {
    this.buttonLanguageTargets.forEach(button => {
      if (button.dataset.language === this.inputLanguageTarget.value) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  // Has Advance ------------------------------------------------------------
  toggle(event) {
    const isChecked = this.hasAdvanceTarget.checked;
    if (isChecked) {
      this.advanceConsumedAmountTarget.value = this.advanceConsumedAmountTarget.dataset.ipConsumedValue || 0;
      this.advanceAmountTarget.value = this.advanceAmountTarget.dataset.ipAdvanceValue || 0;
    }
    this.toggleBasedOnAdvanceState();
    this.updateAdvanceActiveState();
  }

  // Advance Amount y Advance Consumed Amount -------------------------------
  toggleBasedOnAdvanceState() {
    const isChecked = this.hasAdvanceTarget.checked;
    this.toggleDisabledState(this.advanceAmountTarget, isChecked);
    this.toggleDisabledState(this.advanceConsumedAmountTarget, isChecked);
  }

  updateAdvanceActiveState() {
    const advanceAmountString = this.advanceAmountTarget.value;
    const normalizedValue = advanceAmountString.replace(/\./g, '').replace(/,/g, '.');

    const advanceAmount = Number(normalizedValue);
    const advanceConsumedAmount = parseFloat(this.advanceConsumedAmountTarget.textContent);
    const isActive = advanceAmount > advanceConsumedAmount;

    this.advanceActiveTarget.checked = isActive;
    this.advanceHiddenTarget.value = isActive ? '1' : '0';
  }

  toggleDisabledState(target, isChecked) {
    target.disabled = !isChecked;
    if (isChecked) {
      target.classList.remove('bg-gray-200', 'cursor-not-allowed');
    } else {
      target.classList.add('bg-gray-200', 'cursor-not-allowed');
      if (target.type === "checkbox") {
        target.checked = false;
      } else {
        target.value = "";
      }
    }
  }

  // Different Percent y Applicable Percent -----------------------------------
  togglePercent(event) {
    this.syncApplicablePercentState(event.target.checked);
  }

  syncApplicablePercentState(isChecked) {
    if (!this.hasApplicablePercentTarget) return;

    this.toggleDisabledState(this.applicablePercentTarget, isChecked);
    this.syncApplicablePercentHiddenField(isChecked);
  }

  syncApplicablePercentHiddenField(isChecked) {
    const input = this.applicablePercentTarget;
    const form = input.form;
    if (!form) return;

    const name = input.name;
    let hidden = form.querySelector(`input[data-applicable-percent-clear="true"][name="${name}"]`);

    if (isChecked) {
      if (hidden) hidden.remove();
      return;
    }

    if (!hidden) {
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = name;
      hidden.dataset.applicablePercentClear = "true";
      input.insertAdjacentElement("afterend", hidden);
    }
    hidden.value = "";
  }

  // Calculation Base ----------------------------------------------------------------------
  changeCalculationBase(event) {
    event.preventDefault();
    let selectedCalculationBase = event.currentTarget.dataset.state;
    this.updateCalculationBaseButtons(selectedCalculationBase);
    this.inputCalculationBaseTarget.value = selectedCalculationBase;
  }

  updateCalculationBaseButtons(selectedCalculationBase) {
    this.buttonCalculationBaseTargets.forEach((button) => {
      if (button.dataset.state === selectedCalculationBase) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  // Periodicity----------------------------------------------------------------------
  changePeriodicityBase(event) {
    event.preventDefault();
    let selectedPeriodicityBase = event.currentTarget.dataset.state;
    this.updatePeriodicityBaseButtons(selectedPeriodicityBase);
    this.inputPeriodicityBaseTarget.value = selectedPeriodicityBase;
  }

  updatePeriodicityBaseButtons(selectedPeriodicityBase) {
    this.buttonPeriodicityBaseTargets.forEach((button) => {
      if (button.dataset.state === selectedPeriodicityBase) {
        button.classList.remove('bg-white', 'text-green-mga');
        button.classList.add('bg-green-mga', 'text-white');
      } else {
        button.classList.remove('bg-green-mga', 'text-white');
        button.classList.add('bg-white', 'text-green-mga');
      }
    });
  }

  // Game ----------------------
  search() {
    const searchString = this.inputTarget.value.toLowerCase()

    this.gameTargets.forEach((game) => {
      const gameName = game.innerText.toLowerCase()
      const checkbox = game.querySelector('input[type="checkbox"]')

      if (gameName.includes(searchString) || checkbox.checked) {
        game.style.display = "flex"
      } else {
        game.style.display = "none"
      }
    })
  }

  hideGameList() {
    this.gameTargets.forEach((game) => {
      const checkbox = game.querySelector('input[type="checkbox"]')

      if (checkbox.checked) {
        game.style.display = "flex"
      } else {
        game.style.display = "none"
      }
    })
  }

}
